// extracted by mini-css-extract-plugin
export default {"container":"EditHeader_container__1PEN8","content":"EditHeader_content__Y+OVW","btn":"EditHeader_btn__OTEpH"};